import { create } from "zustand";
import { type DevtoolsOptions, devtools } from "zustand/middleware";
import type {
  BroadcastKMGroup,
  PodcastKMGroup,
} from "@/data-access/discovery-view/queries/key-message-queries";

interface DiscoveryKeyMessageStore {
  broadcastGroups: BroadcastKMGroup[];
  isFetchingBroadcast: boolean;
  broadcastGroupsError: string | null;
  selectedBroadcastKeyMessageIds: string[];
  podcastGroups: PodcastKMGroup[];
  isFetchingPodcast: boolean;
  podcastGroupsError: string | null;
  selectedPodcastKeyMessageIds: string[];
  setBroadcastGroups: (groups: BroadcastKMGroup[]) => void;
  setIsFetchingBroadcast: (v: boolean) => void;
  setBroadcastGroupsError: (error: string | null) => void;
  setSelectedBroadcastKeyMessageIds: (ids: string[]) => void;
  setPodcastGroups: (groups: PodcastKMGroup[]) => void;
  setIsFetchingPodcast: (v: boolean) => void;
  setPodcastGroupsError: (error: string | null) => void;
  setSelectedPodcastKeyMessageIds: (ids: string[]) => void;
  reset: () => void;
}

const initialState = {
  broadcastGroups: [] as BroadcastKMGroup[],
  isFetchingBroadcast: false,
  broadcastGroupsError: null as string | null,
  selectedBroadcastKeyMessageIds: [] as string[],
  podcastGroups: [] as PodcastKMGroup[],
  isFetchingPodcast: false,
  podcastGroupsError: null as string | null,
  selectedPodcastKeyMessageIds: [] as string[],
};

const useDiscoveryKeyMessageStore = create<DiscoveryKeyMessageStore>()(
  devtools(
    (set) => ({
      ...initialState,
      setBroadcastGroups: (groups) => set({ broadcastGroups: groups }),
      setIsFetchingBroadcast: (v) => set({ isFetchingBroadcast: v }),
      setBroadcastGroupsError: (error) => set({ broadcastGroupsError: error }),
      setSelectedBroadcastKeyMessageIds: (ids) =>
        set({ selectedBroadcastKeyMessageIds: ids }),
      setPodcastGroups: (groups) => set({ podcastGroups: groups }),
      setIsFetchingPodcast: (v) => set({ isFetchingPodcast: v }),
      setPodcastGroupsError: (error) => set({ podcastGroupsError: error }),
      setSelectedPodcastKeyMessageIds: (ids) =>
        set({ selectedPodcastKeyMessageIds: ids }),
      reset: () => set(initialState),
    }),
    {
      name: "discovery-key-message-store",
      serialize: {
        options: true,
      },
    } as unknown as DevtoolsOptions,
  ),
);

export default useDiscoveryKeyMessageStore;
